import React, { useState } from 'react';
import Expediente_AH from '../images/icons/Expediente_AH.svg';
import Expediente_FG from '../images/icons/Expediente_FG.svg';
//import Expediente_AH from '../images/Expediente_AH.png';
//import Expediente_FG from '../images/Expediente_FG.png';
import Watcher from '../components/Watcher';
import { useParams } from 'react-router-dom';

export default function GLIFOSLigthBox(props) {
	const { apiService } = props;
	const [showWatcher, setShowWatcher] = useState(false);
	const [link, setLink] = useState('');
	const {isadg} = useParams();
	return (
		<>
			<div
				className='g-vw-expediente'
				onClick={() => {
					setShowWatcher(true);
					setLink('https://www.youtube.com/embed/vidtyyLiaIs');
				}}>
				<img src={isadg.includes('GT-CIRMA-FG') ? Expediente_FG : Expediente_AH} alt='Expediente' />
			</div>
			{showWatcher && (<Watcher
				link={link}
				isadg={isadg}
				apiService={apiService}
				setShowWatcher={setShowWatcher}
			/>)}
		</>
	);
}
